// extracted by mini-css-extract-plugin
export default {"teachersPage":"TeachersPage_teachersPage__mjCeG"};